"use client"

import { Box, Link, IconButton, Text, Flex } from "@chakra-ui/react"
import { HamburgerIcon } from "@chakra-ui/icons"
import { useRef } from "react"
import useSidebarStore from "@/store/SidebarStore"
import useMemberStore from "@/store/MemberStore"

interface MobileHeaderComponentProps {
  locale?: string
}

export default function MobileHeaderComponent({
  locale,
}: MobileHeaderComponentProps) {
  const { toggle: toggleSidebar } = useSidebarStore()
  const btnRef = useRef<HTMLButtonElement>(null)
  const isLoggedIn = useMemberStore((state) => state.checkIsLoggedIn())

  return (
    <Box
      height="68px"
      bgGradient="linear(to-r, #2C2C2C, #252525)"
      width="100%"
      display="flex"
      alignItems="center"
      boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
      borderBottom="1px solid rgba(255, 255, 255, 0.1)"
      position="fixed"
      top="0"
      zIndex="1000">
      {isLoggedIn && (
        <IconButton
          ref={btnRef}
          onClick={toggleSidebar}
          marginLeft="16px"
          icon={<HamburgerIcon />}
          aria-label="Open sidebar"
          variant="ghost"
          color="white"
          _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
        />
      )}
      <Flex alignItems="center" ml={4}>
        <Link
          href="/"
          _hover={{ textDecoration: "none", opacity: 0.9 }}
          display="flex"
          alignItems="center">
          <Text
            fontSize="26px"
            fontWeight="bold"
            bgGradient="linear(to-r, #ff4d4d, #ff8080)"
            bgClip="text"
            letterSpacing="tight">
            Threadslytics
          </Text>
        </Link>
      </Flex>
    </Box>
  )
}
